const GoogleMaps = require('./../../../../global/js/modules/google-maps');

document.addEventListener('DOMContentLoaded', () => {
    // if (document.querySelector('html.location-group')) {
    //     return;
    // }

    let $mapElement = document.querySelector('#locations-index-map'),
        $coordinateElements = document.querySelectorAll('[type="text/gps-coordinates"]')
    ;

    if (!$mapElement || $coordinateElements.length === 0) {
        return;
    }

    let markers = [], bounds;

    GoogleMaps.insertMap($mapElement).then((map) => {

        bounds = new google.maps.LatLngBounds();

        for (let $coordElement of $coordinateElements) {
            const coordinate = JSON.parse($coordElement.innerText);

            if (!coordinate || !coordinate.lat || !coordinate.lng) {
                continue;
            }

            $coordElement._infoWindow = new google.maps.InfoWindow({
                content: $coordElement.parentNode.innerHTML
            });
            $coordElement._marker = new google.maps.Marker({
                position: coordinate,
                map: map,
            });

            $coordElement._marker.addListener('click', () => {
                $coordElement._infoWindow.open(map, $coordElement._marker);
            });

            $coordElement._marker.setMap(map);

            bounds.extend($coordElement._marker.getPosition());

            markers.push($coordElement._marker);
        }

        map.fitBounds(bounds);

    });

});

